// import CategoryDataSource from "../CategoryDataSource";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import OrderDataSource from "../OrderDataSource";
import { OrdersAPIEntity } from "./Entity/OrdersAPIEntity";

import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { AddressDetailDataEntity, CustomerDataEntity, DetailProductDataEntity, OrderAPIEntity, ProductDataEntity } from "./Entity/OrderAPIEntity";

const routeName = `/v1/order`;
export default class OrderAPIDataSourceImpl implements OrderDataSource{

      
  async getOrders(
    page = 0,
    pageSize = 10,
    orderCode: string,
    sortOrder: string= '',
    orderStatus: any,
    PaymentMethod: any,
    DeliveryMethod: any,
    fromDate: string,
    toDate: string,
    SortColumn: string
  ): Promise<PaginationResult<OrdersAPIEntity>> {

    const params: any = {
      page,
      pageSize,
      orderCode,
      sortOrder,
      orderStatus,
      PaymentMethod,
      DeliveryMethod,
      fromDate,
      toDate,
      SortColumn
    };
    console.log("params", params);

    // Elimina los undefined
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

    try {
      const response = await api.get<ApiResponse<any>>(routeName, { params });
      const data = response.data?.data;
  
      if (data && Array.isArray(data.items)) {
        const orders: OrdersAPIEntity[] = data.items.map((item: OrdersAPIEntity) => ({
          id: item.id,
          orderCode: item.orderCode,
          customerId: item.customerId,
          customerFirstname: item.customerFirstname,
          customerLastName: item.customerLastName,
          orderStatus: item.orderStatus,
          total: item.total,
          paymentMethod: item.paymentMethod,
          deliveryMethod: item.deliveryMethod,
          deliveryDate: item.deliveryDate,
          created: item.created
        }));

        return {
          items: orders,
          page: data.page,
          pageSize: data.pageSize,
          totalCount: data.totalCount,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPreviousPage,
        };
      } else {
        throw new Error("La respuesta no tiene el formato esperado");
      }
    } catch (error) {
      console.error("Error al obtener las ordenes:", error);
      throw new Error("Error al obtener las ordenes");
    }
  }

  async getOrderById(orderId: number): Promise<OrderAPIEntity | null> {
    try {;

    const response = await api.get<ApiResponse<any>>(`${routeName}/${orderId}`);

    const order = response.data?.data;
    if (!order) return null;

    const customer = order.customer;
    const customerData: CustomerDataEntity = {
      firstName: customer?.firstName ?? "",
      lastName: customer?.lastName ?? "",
      dni: customer?.dni ?? "",
      email: customer?.email ?? "",
      phoneNumber: customer?.phoneNumber ?? "",
    };

    const address = order.addressDetail;
    const addressDetailData: AddressDetailDataEntity = {
      department: address?.department ?? "",
      province: address?.province ?? "",
      district: address?.district ?? "",
      street: address?.street ?? "",
      streetNumber: address?.streetNumber ?? "",
      reference: address?.reference ?? "",
      additionalInfo: address?.additionalInfo ?? "",
      recipient: address?.recipient ?? ""
    };

    const detailsData: DetailProductDataEntity[] = Array.isArray(order.details)
      ? order.details.map((d: any) => {
          const product = d.product;
          const productData: ProductDataEntity = {
            productId: product?.productId ?? 0,
            name: product?.name ?? "",
            discountPrice: product?.discountPrice ?? 0,
            salePrice: product?.salePrice ?? 0,
            bankTransferPrice: product?.bankTransferPrice ?? 0,
            yapePrice: product?.yapePrice ?? 0,
            mainPhoto: product?.mainPhoto ?? "",
            discountPercentage: product?.discountPercentage ?? 0,
            stock: product?.stock ?? 0,
            sku: product?.sku ?? "",
            model: product?.model ?? "",
            color: product?.color ?? "",
            brand: product?.brand ?? "",
          };

          return {
            product: productData,
            quantity: d?.quantity ?? 0,
            amount: d?.amount ?? 0,
            price: d?.price ?? 0,
          };
        })
      : [];


    return {
      orderId: order.orderId,
      customerId: order.customerId,
      customer: customerData,
      description: order.description ?? "",
      orderCode: order.orderCode,
      orderStatus: order.orderStatus,
      paymentReceipt: order.paymentReceipt,
      subtotal: order.subtotal,
      total: order.total,
      shippingCost: order.shippingCost,
      isReview: order.isReview,
      paymentMethod: order.paymentMethod,
      deliveryMethod: order.deliveryMethod,
      pickupLocation: order.pickupLocation ?? "",
      address: order.address,
      addressDetail: addressDetailData,
      contact: order.contact,
      km: order.km,
      ip: order.ip,
      deliveryDate: order.deliveryDate,
      created: order.created,
      ruc: order.ruc,
      voucherUrl: order.voucherUrl,
      isValid: order.isValid,
      payLinkCount: order.payLinkCount,
      addressCustomerId: order.addressCustomerId,
      createdAtPayLink: order.createdAtPayLink,
      createdAtAcceptVoucher: order.createdAtAcceptVoucher,
      details: detailsData,
    }; 
      } catch (error) {
        console.error("Error al obtener los detalle de orden:", error);
        return null;
      }
  }

  async updateOrderStatus(data: any): Promise<boolean> {
    try {
    
      const response = await api.post<ApiResponse<any>>(`${routeName}/update-order-status`, data);

      if (response.data?.succeeded) {
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
      
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false;
    }
  }

  async updateDeliveryDate(data: any): Promise<boolean> {
    try {
    
      const response = await api.post<ApiResponse<any>>(`${routeName}/update-order-datedelivery`, data);

      if (response.data?.succeeded) {
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
      
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false;
    }
  }
  async addingInvoice(data: any): Promise<boolean>{
    // console.log("FORM DATA addingInvoice", data);
    //  for (const pair of data.entries()) {
    //         console.log(`${pair[0]}:`, pair[1]);
    //     }
    try {
    
      const response = await api.post<ApiResponse<any>>(`${routeName}/adding-invoice`, data);

      if (response.data?.succeeded) {
        return true;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.data);
        return false;
      }
    } catch (error: any) {
      
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return false;
    }
  }
  async getOrderTicketById(id: number):Promise<any>{
  console.log("id", id);
    try {
    
      const response = await api.get<ApiResponse<any>>(`${routeName}/${id}/ticket`,{
        responseType: "blob",
      }
        
         
      );

      if (response.status===200) {
        return response.data;
      } else {
        console.warn("La API respondió con un formato inesperado:", response.statusText);
        return "";
      }
    } catch (error: any) {
      
        if (error.response) {
          console.error(`Error ${error.response.status}:`, error.response.data);
        } else {
          console.error("Error de red o de servidor:", error.message);
        }
        return "";
    }
  }
}